export default __webpack_public_path__ + "static/media/muted.ad575ddd.svg";